import { render, staticRenderFns } from "./TaxationForm.vue?vue&type=template&id=458ce1a6&scoped=true"
import script from "./TaxationForm.vue?vue&type=script&lang=js"
export * from "./TaxationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458ce1a6",
  null
  
)

export default component.exports